var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "test-wrapper" }, [
    !_vm.testPreview
      ? _c("section", [
          _vm._v(
            "\n\t\t" + _vm._s(_vm.$t("MAIN_CONTENT.testTaker.loading")) + "\n\t"
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.testPreview && !_vm.reviewStarted
      ? _c("section", [
          _c("div", { staticClass: "pre-test" }, [
            _c("div", { staticClass: "display-table" }, [
              _c("div", { staticClass: "header text-center" }, [
                _c("h2", [_vm._v(_vm._s(_vm.testPreview.TEST.TEST_TITLE))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm.testPreview.TEST.TEST_DESCRIPTION
                  ? _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.testPreview.TEST.TEST_DESCRIPTION)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "test-meta" }, [
                  _c("div", [
                    _c("label", [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("MAIN_CONTENT.testReviewer.started")) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pill pill-gray-light" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.testPreview.STUDENT_ATTEMPT.TEST_BEG_DATE
                          ) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.testReviewer.submitted")
                          ) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pill pill-gray-light" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.testPreview.STUDENT_ATTEMPT.TEST_END_DATE
                          ) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("MAIN_CONTENT.commonContent.score")) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pill pill-gray-light" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.testReviewer.scoreOfTotalScore",
                              {
                                score:
                                  _vm.testPreview.STUDENT_ATTEMPT.TOTAL_SCORE,
                                total: _vm.testPreview.TEST.TOTAL_SCORE
                              }
                            )
                          ) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "foo text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.initReview()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.testReviewer.reviewMyTest")
                          ) +
                          " "
                      ),
                      _c("i", { staticClass: "fas fa-chevron-right" })
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.testPreview && _vm.reviewStarted
      ? _c("section", [
          _c("div", { staticClass: "test-header" }, [
            _c("h1", [_vm._v(_vm._s(_vm.testPreview.TEST.TEST_TITLE))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9" }, [
              _c(
                "div",
                {
                  staticClass: "testing-zone",
                  attrs: { id: "testZone", tabindex: "-1" }
                },
                [
                  _c("div", { staticClass: "total-score-badge-bar" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.testReviewer.scoreOfTotalScorePossible",
                            {
                              score:
                                _vm.testPreview.STUDENT_ATTEMPT.TOTAL_SCORE,
                              total: _vm.testPreview.TEST.TOTAL_SCORE
                            }
                          )
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _vm.activeQuestion && _vm.activeQuestion.QUESTION_TYPE
                    ? _c("question-group", {
                        attrs: { group: _vm.activeQuestionGroup }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeQuestion && _vm.activeQuestion.QUESTION_TYPE
                    ? _c(
                        "div",
                        {
                          attrs: {
                            "aria-live":
                              _vm.activeQuestion.SEQUENCE === 1
                                ? "off"
                                : "assertive"
                          }
                        },
                        [
                          _c("div", { staticClass: "extra-credit" }, [
                            _vm.activeQuestion.EXTRA_CREDIT_FLG
                              ? _c(
                                  "span",
                                  { staticClass: "pill pill-success-lighten" },
                                  [
                                    _vm.activeQuestion.EXTRA_CREDIT_FLG
                                      ? _c("font-awesome-icon", {
                                          attrs: {
                                            icon: "certificate",
                                            size: "2x",
                                            title: "Extra Credit Question"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "hidden-xs" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.testReviewer.extraCredit"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE === "C"
                            ? _c("multiple-choice-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  testMode: _vm.testModeActual
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE === "T"
                            ? _c("true-false-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  testMode: _vm.testModeActual
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE === "S"
                            ? _c("short-fill-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  blankAnswer: _vm.blankAnswer,
                                  testMode: _vm.testModeActual
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE === "M"
                            ? _c("matching-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  questions: _vm.questions,
                                  answers: _vm.answers,
                                  test: _vm.test,
                                  testMode: _vm.testModeActual
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE === "N"
                            ? _c("numeric-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  blankAnswer: _vm.blankAnswer,
                                  testMode: _vm.testModeActual
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE === "E"
                            ? _c("essay-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  blankAnswer: _vm.blankAnswer,
                                  testMode: _vm.testModeActual
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _c("div", [
                        _c("div", { staticClass: "panel panel-basic" }, [
                          _c("div", { staticClass: "panel-heading" }, [
                            _c("h2", [
                              _vm._v(_vm._s(_vm.testPreview.TEST.TEST_TITLE))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "panel-body" }, [
                            _c("p", [
                              _c("b", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.testReviewer.takeTester_finishedReview"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "panel-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    return _vm.closeWindow()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.testTaker.takeTester_closeWindow"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("aside", [
                _c(
                  "div",
                  { staticClass: "question-nav" },
                  [_c("question-selector")],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "score-wrap text-center" }, [
                  _c("span", { staticClass: "pill pill-dark" }, [
                    _c("strong", [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.testReviewer.scoreOutOfTotal",
                              {
                                score:
                                  _vm.testPreview.STUDENT_ATTEMPT.TOTAL_SCORE,
                                total: _vm.testPreview.TEST.TOTAL_SCORE
                              }
                            )
                          ) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("MAIN_CONTENT.testReviewer.points")) +
                        " \n\t\t\t\t\t\t"
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }